import { Injectable } from '@angular/core';
import { CrudService } from '@aid/shared/services';
import { CustomerLegalForm } from '@aid/customers/types/classes';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CustomerLegalFormsService extends CrudService<CustomerLegalForm> {
  constructor(private http: HttpClient) {
    super(http);
  }
  get url() {
    return 'legal-forms';
  }
}
